import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const PrivacyPolicy = lazy(() => import("@/pages/policies/PrivacyPolicy"));

export const Route = createFileRoute("/_public/privacy")({
  component: PrivacyPolicy,
});
